import Cookies from 'js-cookie';

export const LOCATION_ID_COOKIE = 'location-id';

export const LOCATION_ALL_COOKIE_VALUE = 'ALL';

export const LOCATION_ID_COOKIE_CHANGE_EVENT = 'location-id-cookie-change';

export const cookieToLocationId = (raw) =>
  !raw || raw === LOCATION_ALL_COOKIE_VALUE ? null : raw;

export const setLocationIdCookie = (value) => {
  Cookies.set(LOCATION_ID_COOKIE, value || LOCATION_ALL_COOKIE_VALUE);
  window.dispatchEvent(new Event(LOCATION_ID_COOKIE_CHANGE_EVENT));
};
